import { z } from 'zod';
import { defineEvents } from '@ndrc/app-sdk/events';
import fr from './messages/fr.json' with { type: 'json' };
export const events = defineEvents({
  'campaigns.changed': {
    schema: z.object({ id: z.uuid() }),
    journal: { label: fr.changedEvent, importance: 'normal' },
    realtime: true,
  },
  'campaigns.run.due': {
    schema: z.object({ id: z.uuid() }),
    journal: { label: fr.dueEvent, importance: 'normal' },
    realtime: true,
  },
});
